import { render, staticRenderFns } from "./component_detection_item_pc.vue?vue&type=template&id=b0a68a3c&scoped=true&"
import script from "./component_detection_item_pc.vue?vue&type=script&lang=js&"
export * from "./component_detection_item_pc.vue?vue&type=script&lang=js&"
import style0 from "./component_detection_item_pc.vue?vue&type=style&index=0&id=b0a68a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a68a3c",
  null
  
)

export default component.exports